// Create a new component: src/components/employer/ScheduleDisplay.js
import React from 'react';
import { Table, Badge, Tabs, Tab } from 'react-bootstrap';

const ScheduleDisplay = ({ schedules }) => {
  const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

  const formatTime = (time) => {
    const [hours, minutes] = time.split(':');
    const hour = parseInt(hours, 10);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const hour12 = hour % 12 || 12;
    return `${hour12}:${minutes} ${ampm}`;
  };

  return (
    <Tabs defaultActiveKey="0" className="mb-3">
      {schedules.map((schedule, index) => (
        <Tab key={index} eventKey={index.toString()} title={`Option ${index + 1}`}>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Day</th>
                <th>Shifts</th>
              </tr>
            </thead>
            <tbody>
              {days.map(day => (
                <tr key={day}>
                  <td className="text-capitalize">{day}</td>
                  <td>
                    {schedule[day]?.length > 0 ? (
                      schedule[day].map((shift, shiftIndex) => (
                        <Badge 
                          key={shiftIndex} 
                          bg="primary" 
                          className="me-2 mb-1 p-2"
                        >
                          {shift.employee}: {formatTime(shift.start)} - {formatTime(shift.end)}
                        </Badge>
                      ))
                    ) : (
                      <Badge bg="secondary">No shifts</Badge>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Tab>
      ))}
    </Tabs>
  );
};

export default ScheduleDisplay;